// extracted by mini-css-extract-plugin
export default {"labelBackground":"CustomSelect_labelBackground__HcCpq","noPadding":"CustomSelect_noPadding__+FlTJ"};